import { 
  DELETE_BRANDKIT_COMPONENT, UPDATE_BRANDKIT_COMPONENT_PROPERTY, 
  UPDATE_BRANDKIT_COMPONENT_CONTENT, RENAME_BRANDKIT_COMPONENT, ASSOCIATE_FONTS_WITH_BRANDKIT_COMPONENT,
  CREATE_BRANDKIT_COMPONENT_REQUEST, CREATING_BRANDKIT_COMPONENT_SUCCEEDED, CREATING_BRANDKIT_COMPONENT_FAILED,
  FETCHING_BRANDKIT_COMPONENTS_REQUEST, FETCHING_BRANDKIT_COMPONENTS_SUCCEEDED, FETCHING_BRANDKIT_COMPONENTS_FAILED,
  FETCHING_PALETTE_COMPONENT_EDITOR_REQUEST, FETCHING_PALETTE_COMPONENT_EDITOR_SUCCEEDED, FETCHING_PALETTE_COMPONENT_EDITOR_FAILED,
  UPDATE_PALETTE_COMPONENT_REQUEST, UPDATING_PALETTE_COMPONENT_SUCCEEDED, UPDATING_PALETTE_COMPONENT_FAILED,
  PUBLISH_PALETTE_COMPONENT_REQUEST, PUBLISHING_PALETTE_COMPONENT_SUCCEEDED, PUBLISHING_PALETTE_COMPONENT_FAILED,
  DELETE_BRANDKIT_COMPONENTS_REQUEST, DELETING_BRANDKIT_COMPONENTS_SUCCEEDED, DELETING_BRANDKIT_COMPONENTS_FAILED,
  UPDATE_BRANDKIT_COMPONENTS_REQUEST, UPDATING_BRANDKIT_COMPONENTS_SUCCEEDED, UPDATING_BRANDKIT_COMPONENTS_FAILED,
  INVALIDATE_PALETTE_COMPONENT, RENAME_PALETTE_COMPONENT_REQUEST,
  INVALIDATE_BRANDKIT_COMPONENT,
  RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED
  } from "constants/actionTypes";
    
  import _ from 'lodash';
    
    const initialState = {
      loading: false,
      updating: false,
      fetched: false,
      invalidated: false,
      errorType: null,
      items: [],
      components: [],
      invalidated: false,
      paletteComponent: {
        item: null,
        loading: false,
        create: {
          id: null,
          creating: false,
          created: false,
          error: null
        },
        update: {
          id: null,
          updating: false,
          updated: false,
          error: null
        },
        publish: {
          id: null,
          publishing: false,
          published: false,
          error: null
        },
        clone: {
          id: null,
          cloning: false,
          cloned: false,
          error: null
        },
        invalidated: false
      },
    }
  
    
    export function brandKitComponentsReducer(state = initialState, action) {
      switch (action.type) {

        case DELETE_BRANDKIT_COMPONENT: {
          const { ids } = action.payload;

          const updatedComponents = state.components.filter(component => !ids.includes(component.id));

          return {
            ...state,
            components: updatedComponents
          }

        }

        case UPDATE_BRANDKIT_COMPONENT_PROPERTY: {
          const { id, widget_uid, property } = action.payload;
        
          const components = state.components || [];
          
          const updatedComponents = components.map(component => {
            if (component.id === id) {
              const updatedWidgets = component.draft.widgets.map(widget => {
                if (widget.uid === widget_uid) {
                  return {
                    ...widget,
                    properties: property
                  };
                }
                return widget;
              });
        
              return {
                ...component,
                changes: true,
                draft: {
                  ...component.draft,
                  widgets: updatedWidgets,
                },
              };
            }
            return component;
          });
        
          return {
            ...state,
            components: updatedComponents,
          };
        }
        
        case UPDATE_BRANDKIT_COMPONENT_CONTENT: {
          const { id, widget_uid, content } = action.payload;

          const components = state.components || [];

          const updatedComponents = components.map(component => {
            if (component.id === id) {
              const updatedWidgets = component.draft.widgets.map(widget => {
                if (widget.uid === widget_uid) {
                  return {
                    ...widget,
                    content: content
                  };
                }
                return widget;
              });
        
              return {
                ...component,
                changes: true,
                draft: {
                  ...component.draft,
                  widgets: updatedWidgets,
                },
              };
            }
            return component;
          });
        
          return {
            ...state,
            components: updatedComponents,
          };
        }

        case RENAME_BRANDKIT_COMPONENT: {
          const { id, name } = action.payload;

          const components = state.components || [];

          const updatedComponents = components.map(component => {
            if (component.id === id) {
              return {
                ...component,
                changes: true,
                name: name,
              };
            }
            return component;
          });
        
          return {
            ...state,
            components: updatedComponents,
          };
        }

        case ASSOCIATE_FONTS_WITH_BRANDKIT_COMPONENT: {
          const { id, widget_uid, fonts } = action.payload;
  
          const components = state.components || [];
  
          const updatedComponents = components.map(component => {
            if (component.id === id) {
              const updatedWidgets = component.draft.widgets.map(widget => {
                if (widget.uid === widget_uid) {
                  return {
                    ...widget,
                    fonts: fonts
                  };
                }
                return widget;
              });
        
              return {
                ...component,
                changes: true,
                draft: {
                  ...component.draft,
                  widgets: updatedWidgets,
                },
              };
            }
            return component;
          });
        
          return {
            ...state,
            components: updatedComponents,
          };
        }

        case INVALIDATE_PALETTE_COMPONENT: {
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              create: {
                item: null,
                creating: false,
                created: false,
                error: null
              },
              clone: {
                id: null,
                cloning: false,
                cloned: false,
                error: null
              },
              update: {
                updating: false,
                updated: false,
                error: null
              },
              publish: {
                publishing: false,
                published: false,
                error: null
              }
            }
          }
        }

        case CREATE_BRANDKIT_COMPONENT_REQUEST: {
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              create: {
                item: null,
                creating: true,
                created: false,
                error: null
              }
            }
          }
        }
          
        case CREATING_BRANDKIT_COMPONENT_SUCCEEDED: {
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              create: {
                item: action.payload,
                creating: false,
                created: true,
                error: null
              }
            }
          }
        }
          
        case CREATING_BRANDKIT_COMPONENT_FAILED: {
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              create: {
                item: null,
                creating: false,
                created: false,
                error: action.payload
              }
            }
          }
        }
    
        case FETCHING_BRANDKIT_COMPONENTS_REQUEST: {
          return {
            ...state,
            fetching: true
          }
        }
        
        case FETCHING_BRANDKIT_COMPONENTS_SUCCEEDED: {
          return {
            ...state,
            fetching: false,
            items: action.payload,
            components: action.payload.components
          }
        }
    
        case FETCHING_BRANDKIT_COMPONENTS_FAILED: {
          return {
            ...state,
            fetching: false,
            error: action.payload
          }
        }

        case FETCHING_PALETTE_COMPONENT_EDITOR_REQUEST: {
          const id = action.payload;
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              [id]: {
                loading: true,
                item: null
              }
            }
          }
        }
    
        case FETCHING_PALETTE_COMPONENT_EDITOR_SUCCEEDED: {
          const paletteComponent = action.payload;
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              [paletteComponent.id]: {
                loading: false,
                item: paletteComponent
              }
            }
          }
        }
    
        case FETCHING_PALETTE_COMPONENT_EDITOR_FAILED: {
          const { id, error } = action.payload;
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              [id]: {
                loading: false,
                item: null,
                error: error
              }
            }
          }
        }

        case UPDATE_PALETTE_COMPONENT_REQUEST:
        case RENAME_PALETTE_COMPONENT_REQUEST: {
            return {
              ...state,
              paletteComponent: {
                ...state.paletteComponent,
                update: {
                  ...state.paletteComponent.item,
                  updating: true,
                  updated: false,
                  error: null
                }
              }
            }
          }
            
        case UPDATING_PALETTE_COMPONENT_SUCCEEDED: {
          const {id, response} = action.payload;
    
          const elementState = state.paletteComponent[id];
          if(!elementState){
            return state;
          }
          
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              update: {
                updating: false,
                updated: true,
                error: null
              },
              [id]: {
                ...elementState,
                item: response
              }
            }
          }
        }
          
        case UPDATING_PALETTE_COMPONENT_FAILED: {
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              update: {
                updating: false,
                updated: false,
                error: action.payload
              }
            }
          }
        }

        case PUBLISH_PALETTE_COMPONENT_REQUEST: {
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              publish: {
                publishing: true,
                published: false,
                error: null
              }
            }
          }
        }
          
        case PUBLISHING_PALETTE_COMPONENT_SUCCEEDED: {
          const {id, response} = action.payload;
    
          const elementState = state.paletteComponent[id];
          if(!elementState){
            return state;
          }
    
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              publish: {
                publishing: false,
                published: true,
                error: null
              },
              [id]: {
                ...elementState,
                item: response
              }
            }
          }
        }
          
        case PUBLISHING_PALETTE_COMPONENT_FAILED: {
          return {
            ...state,
            paletteComponent: {
              ...state.paletteComponent,
              publish: {
                publishing: false,
                published: false,
                error: action.payload
              }
            }
          }
        }
    
        case DELETE_BRANDKIT_COMPONENTS_REQUEST: {
  
          return {
              ...state,
              deleting: true,
            }
        }
    
        case DELETING_BRANDKIT_COMPONENTS_SUCCEEDED: {
          const { ids, response } = action.payload;
          
          const components = state.components.filter(item => (!(ids).includes(item.id)));
    
          return {
            ...state,
            loading: false,
            deleting: false,
            components: components,
          }
        }
    
        case DELETING_BRANDKIT_COMPONENTS_FAILED: {
          return {
            ...state,
            deleting: false,
            loading: false,
            error: action.payload.error[0]
          }
        }
    
        case UPDATE_BRANDKIT_COMPONENTS_REQUEST: {
          return {
            ...state,
            loading: true,
            updating: true
          }
        }
          
        case UPDATING_BRANDKIT_COMPONENTS_SUCCEEDED: { 
          const {response} = action.payload;

          return {
            ...state,
            loading: false,
            updating: false,
            updated: true,
            items: response,
            components: response.components
          }
        }
          
        case UPDATING_BRANDKIT_COMPONENTS_FAILED: {
          return {
            ...state,
            updating: false,
            loading: false,
            error: action.payload.error[0]
          }
        }

        case RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED: {
          const { response, type } = action.payload;
          const components = state.components || [];

          // if type has value return the state without updating components
          if (type) {
            return state;
          }
          
          let items = [response, ...(components || [])];
          items = _.uniqBy(items, 'id');
  
          return {
            ...state,
            components: items,
          }
        }

        case INVALIDATE_BRANDKIT_COMPONENT: {
          return {
            ...state,
            loading: false,
            updating: false,
            updated: false,
            fetched: false,
            invalidated: false,
            errorType: null,
            invalidated: false
          }
        }
           
        default:
          return state;
      }
    }